// extracted by mini-css-extract-plugin
export var bgTL = "CTA-module--bgTL--cb9b4";
export var bgTR = "CTA-module--bgTR--28894";
export var content = "CTA-module--content--a68b5";
export var root = "CTA-module--root--9b183";